import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import orderBy from "lodash/orderBy";

export default function EditableWarehouseFilter({
  warehouse,
  warehouses = [],
  onWarehouseChange,
  label = "Warehouse",
  mb = 2,
}) {
  const sortedWarehouses = orderBy(warehouses, v => v.name);

  const handleWarehouseChange = (event, newValue) => {
    onWarehouseChange(newValue);
  };

  return (
    <Box mb={mb}>
      <Autocomplete
        value={warehouse}
        onChange={handleWarehouseChange}
        options={sortedWarehouses}
        getOptionLabel={option => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
        renderInput={params => (
          <TextField {...params} label={label} variant="outlined" fullWidth size="small" />
        )}
        clearable
      />
    </Box>
  );
}
